import React, { Fragment, useState } from 'react'

import { AppearingWrapper, SectionContainer } from 'Components/Blocks'
import { SubsectionTitle } from 'Components/Blocks/Titles'
import FAQAccordion from 'Components/Sections/FAQ/Accordion'
import { Column } from 'Components/UI'

import { LANDING_CONTENT_PX } from 'Constants/Landing'

import { FaqRecordFieldsFragment } from 'GraphQL/DatoCMS/TypedDocuments'

import { Container, Content, Divider } from './styles'

type Props = {
  data?: FaqRecordFieldsFragment[]
}

function FAQSection({ data }: Props) {
  const [openedQuestionId, setOpenedQuestionId] = useState(undefined)

  if (!data) return null

  return (
    <SectionContainer>
      <AppearingWrapper centered>
        <Container>
          <AppearingWrapper centered>
            <Content px={LANDING_CONTENT_PX} py={[44, 44, 80, 80, 100]}>
              <SubsectionTitle centered title="Frequently asked questions" />

              <Column alignCenter fullWidth maxWidth={1200}>
                {data.map((item, index) => (
                  <Fragment key={item.id}>
                    <FAQAccordion
                      data={{ question: item.question, answer: item.answer }}
                      isOpen={item.id === openedQuestionId}
                      onClose={() => setOpenedQuestionId(undefined)}
                      onOpen={() => setOpenedQuestionId(item.id)}
                    />

                    {index + 1 < data.length && <Divider my={5} />}
                  </Fragment>
                ))}
              </Column>
            </Content>
          </AppearingWrapper>
        </Container>
      </AppearingWrapper>
    </SectionContainer>
  )
}

export default FAQSection
